import React from 'react';
import styles from '@app/common/PageHeader/HeaderBar/index.module.less';
import Link from '@base/lib/ThemeLink';
import { RouteEnum } from 'pro/config/routers';
import { useTrans } from 'base/utils/i18n'
import cn from 'classnames';

const HeaderCommunity: React.FC = () => {
    const { t } = useTrans();
    return (
        <div className={cn(
            styles['widget'],
            styles['widget-trigger'],
            styles['widget-trigger-text'],
        )}>
            <Link href={RouteEnum.Community}>
                <a>
                    {t('web_shop_community')}
                </a>
            </Link>
        </div>
    );
};

export default HeaderCommunity